module.exports = __webpack_public_path__ + "static/media/urbangoo17.62d5215c.webp";